import * as types from '../mutationTypes';

const state = {
  title: null,
  id: null,
  status: null,
};

const actions = {
  setCurrentSession({ commit }, payload) {
    commit(types.SET_CURRENT_SESSION, payload);
  },
};

const mutations = {
  [types.SET_CURRENT_SESSION](state, payload) {
    state.title = payload.title;
    state.id = payload.id;
    state.status = payload.status;
  },
};

export const session = {
  namespaced: true,
  state,
  actions,
  mutations,
};
